import axios from 'axios'
import token from '@/storage/token.js'
import { Message } from 'element-ui';

function api_response ({success, message, payload, error}) {
  return {
    success: typeof success !== 'undefined'? success: false,
    message: typeof message !== 'undefined'? message: '', 
    payload: typeof payload !== 'undefined'? payload: null,
    error: typeof error !== 'undefined'? error: null,
  }
}

function downloadFile({response, assigned_file_name, type}) {
  // It is necessary to create a new blob object with mime-type explicitly set
  // otherwise only Chrome works like it should

  let effective_type = 'application/vnd.ms-excel'
  if (typeof type === 'string') {
    effective_type = type
  }

  let newBlob = new Blob([response.data], {type: effective_type})

  let disposition = response.headers['content-disposition']
  let file_name = null
  if (assigned_file_name) {
    file_name = assigned_file_name
  }
  else if (disposition) {
    // Content-Disposition: attachment;filename=export.xlsx;filename*=UTF-8''export.xlsx
    file_name = decodeURI(disposition.substring(
      disposition.indexOf('filename=') + 9, 
      disposition.indexOf(';', disposition.indexOf('filename=') + 9)
    ))    
  }
  else {
    file_name = '匯出檔案.xls'
  }

  // IE doesn't allow using a blob object directly as link href
  // instead it is necessary to use msSaveOrOpenBlob
  if (window.navigator && window.navigator.msSaveOrOpenBlob) {
    window.navigator.msSaveOrOpenBlob(newBlob)
    return true
  }

  // For other browsers:
  // Create a link pointing to the ObjectURL containing the blob.
  const data = window.URL.createObjectURL(newBlob)
  var link = document.createElement('a')
  link.href = data
  link.download = file_name
  link.click()
  setTimeout(function () {
    // For Firefox it is necessary to delay revoking the ObjectURL
    window.URL.revokeObjectURL(data)
  }, 100)
}

function normalize_search_resource_name (resource_name) {
  if (resource_name === 'article/do') {
    return 'article'
  }

  return resource_name
}

export default {
  apiUrl: process.env.VUE_APP_API_BACKSTAGE_URL,

  async login (email, password) {
    axios.defaults.headers.common['Authorization'] = token.getToken()
    let result = await axios
      .post(`${this.apiUrl}/user/login`, {
        email: email,
        password: password
      })
      .then((response) => {
        Message.success({message: '登入成功'})
        return response.data
      })
      .catch((error) => {
        Message.error({message: `登入失敗，${error.response.data.message}`})
        return api_response({
          success: false,
          message: error.response.data.message
        })
      })

    return result
  },
  async logout (email, password) {
    axios.defaults.headers.common['Authorization'] = token.getToken()
    let result = await axios
      .post(`${this.apiUrl}/user/logout`, {
        email: email,
        password: password
      })
      .then((response) => {
        Message.success({message: '登出成功'})
        return response.data
      })
      .catch((error) => {
        console.log('err', error)
        Message.error({message: '登出失敗'})
        return error
      })
    return result
  },
  async reset_pwd ({email, ori_password, new_password, confirm_password}) {
    axios.defaults.headers.common['Authorization'] = token.getToken()
    let result = await axios
      .post(`${this.apiUrl}/user/login-password`, {email, ori_password, new_password, confirm_password})
      .then((response) => {
        return response.data
      })
      .catch((error) => {
        return api_response({
          success: false,
          message: error.response.data.message
        })
      })
    return result
  },
  async get_personal_info (email, password) {
    axios.defaults.headers.common['Authorization'] = token.getToken()
    let result = await axios
      .get(`${this.apiUrl}/user/personal-info`)
      .then((response) => {
        return response.data
      })
      .catch((error) => {

        return error
      })
    return result
  },
  
  //account
  async activate_user (activate, id) {
    axios.defaults.headers.common['Authorization'] = token.getToken()
    let result = await axios
      .post(`${this.apiUrl}/account/activate`, {
        id,
        activate: activate? 1: 0
      })
      .then((response) => {
        return response.data
      })
      .catch((error) => {
        return error
      })
    return result
  },
  async delete_user (id) {
    axios.defaults.headers.common['Authorization'] = token.getToken()
    let result = await axios
      .post(`${this.apiUrl}/account/delete`, {id})
      .then((response) => {
        return response.data
      })
      .catch((error) => {
        return error
      })
    return result
  },
  async get_roles () {
    axios.defaults.headers.common['Authorization'] = token.getToken()
    let result = await axios
      .post(`${this.apiUrl}/role/list`)
      .then((response) => {
        return response.data
      })
      .catch((error) => {
        Message.error({message: '無法取得角色列表'})
        return error
      })
    return result
  },
  async get_account (id) {
    axios.defaults.headers.common['Authorization'] = token.getToken()
    let result = await axios
      .get(`${this.apiUrl}/account/get`,{params:{id}})
      .then((response) => {
        return api_response({
          success: true,
          payload: response.data.payload,
        })
      })
      .catch((error) => {
        Message.error({message: '無法取得帳號資訊'})
        return api_response({
          success: false,
          error: error,
          payload: '無法取得帳號資訊',
        })
      })
    return result
  },
  //review
  async review_article (id, rights_open) {
    //rights_open: 是否於前臺開放, 審核通過後變成開放
    axios.defaults.headers.common['Authorization'] = token.getToken()
    
    console.log('review article: id=', id, ', rights_open=', rights_open)
    
    let ids = null
    if (!Array.isArray(id)) {
      ids = [id]
    }
    else {
      ids = id
    }

    let result = axios
      .post(`${this.apiUrl}/article/online`, {
        system_id: ids,
        online: rights_open
      })
      .then((response) => {
        if (response.status === 200) {
          return api_response({
            success: true,
            payload: response.data.payload,
            message: response.data.message,
          })
        }
        else {
          return api_response({
            success: false,
            message: response.data.message,
          })
        }
      })
      .catch((error) => {
          return api_response({
            error,
            message: error.response.data.message
          })
      })
    return result
  },
  //deputy
  async assign_deputy (id) {
    axios.defaults.headers.common['Authorization'] = token.getToken()
    
    let result = axios
      .post(`${this.apiUrl}/account/set-agent`, {
        fk_agent_user_id: id,
      })
      .then((response) => {
        return api_response({
          success: true,
          payload: response.data,
        })
      })
      .catch((error) => {
        return api_response({error})
      })
    return result
  },
  async cancel_deputy () {
    axios.defaults.headers.common['Authorization'] = token.getToken()
    
    let result = axios
      .post(`${this.apiUrl}/account/reset-agent`)
      .then((response) => {
        return api_response({
          success: true,
          payload: response.data,
        })
      })
      .catch((error) => {
        return api_response({error})
      })
    return result
  },

  //notification
  async get_notification_list () {
    axios.defaults.headers.common['Authorization'] = token.getToken()
    
    let result = axios
      .post(`${this.apiUrl}/system-log/notification-list`)
      .then((response) => {
        return api_response({
          success: true,
          payload: response.data.payload.search_result,
        })
      })
      .catch((error) => {
        return api_response({error})
      })
    return result
  },


  // article
  async get_article (id) {
    axios.defaults.headers.common['Authorization'] = token.getToken()
    
    let result = axios
      .get(`${this.apiUrl}/article/get`, { params: {
        system_id: id
      }})
      .then((response) => {
        return api_response({
          success: true,
          payload: response.data.payload,
        })
      })
      .catch((error) => {
        return api_response({error})
      })
    return result
  },

  // import
  async import_article (type, file) {
    axios.defaults.headers.common['Authorization'] = token.getToken()
    
    let param = new FormData(); 
    param.append('import_file[0]', file.file)
    param.append('series_table_name', type)

    let config = { headers:{'Content-Type':'multipart/form-data'} } 

    let result = axios
      .post(`${this.apiUrl}/article/import`, param, config)
      .then((response) => {
        return api_response({
          success: true,
          payload: response.data.payload,
        })
      })
      .catch((error) => {
        return api_response({
          error: error,
          message: error.response.data.message
        })
      })
    return result
  },
  async download_article_template(type) {
    axios.defaults.headers.common['Authorization'] = token.getToken()

    // let filename = ''
    // switch (type) {
    //   case 'official_document': filename = '公文類'; break
    //   case 'graph': filename = '圖說(技術文件)類'; break
    //   case 'publication': filename = '出版品類'; break
    //   case 'image': filename = '影像類'; break
    //   case 'cultural_relics': filename = '文物器具類'; break
    //   case 'oral_history': filename = '口述歷史類'; break
    //   case 'culture_natural_landscape': filename = '文化自然景觀類'; break
    //   case 'buildings': filename = '建築物、土木設施與遺址類'; break
    //   default: filename = ''; break
    // }
    // filename += '匯入範本'

    let ret = axios.get(`${this.apiUrl}/article/download-template?series_table_name=${type}`, {
      headers: {
        Accept: 'application/vnd.ms-excel',
      },
      responseType: 'arraybuffer'
    })
    .then(response => {
        if (response.status === 200) { 
          try { 
            downloadFile({response})
            return api_response({success: true})
          } catch (error) {
            return api_response({error})
          }
        }
        else {
          return api_response({success: false})
        }
    })
    .catch(error => {
      console.warn('[ERR] failed to download template file, error=', error)
      return api_response({error})
    })

    return ret
  },
  async download_article_do_doc(id) {
    axios.defaults.headers.common['Authorization'] = token.getToken()

    let ret = axios.get(`${this.apiUrl}/article/do/download-doc?id=${id}`, {
      responseType: 'arraybuffer'
    })
    .then(response => {
        if (response.status === 200) { 
          try { 
            downloadFile({response, type: 'application/octet-stream'})
            return api_response({success: true})
          } catch (error) {
            return api_response({error})
          }
        }else {
          return api_response({success: false})
        }
    })
    .catch(error => {
      console.warn('[ERR] failed to download template file, error=', error)
      return api_response({error})
    })

    return ret
  },
  //export
  async export_article (param) {
    console.log('export articles:',param)
    axios.defaults.headers.common['Authorization'] = token.getToken()

    let ret = axios.post(`${this.apiUrl}/article/export`, 
      {
        headers: {
          Accept: 'application/vnd.ms-excel',
        },
        ...param
      },
      { responseType: 'arraybuffer' }
    )
    .then(response => {
        if (response.status === 200) { 
          try {
            downloadFile({response, assigned_file_name: '匯出資料.xlsx'})
            return api_response({success: true})
          } catch (error) {
            return api_response({error})
          }
        }
        else {
          return api_response({success: false})
        }
    })
    .catch(error => {
      console.warn('[ERR] failed to export article, error=', error)
      return api_response({error})
    })

    return ret
  },
  // organization
  async get_article_number_under_organization ( hierarchy_name, hierarchy_id ) {
    axios.defaults.headers.common['Authorization'] = token.getToken()
    
    let result = axios
      .get(`${this.apiUrl}/organization/get`, {params: {
        hierarchy_name,
        hierarchy_id
      }})
      .then((response) => {
        let {
          folder_total,
          series_total,
          sub_recordgroup_total,
          recordgroup_total,
        } = response.data.payload['hierarchy_count']

        let article_total = response.data.payload['article_total']

        switch (hierarchy_name) {
        case 'recordgroup':
          if (article_total > 0) {
            return api_response({
              success: false,
              message: '該全宗尚有資料，無法刪除',
            })
          }

          if (sub_recordgroup_total > 0 || folder_total > 0) {
            return api_response({
              success: false,
              message: '該全宗尚有次全宗(or案卷)資訊，無法刪除',
            })
          }
          break
        case 'sub_recordgroup':
          if (article_total > 0) {
            return api_response({
              success: false,
              message: '該次全宗尚有資料，無法刪除',
            })
          }

          if (folder_total > 0) {
            return api_response({
              success: false,
              message: '該次全宗尚有案卷資訊，無法刪除',
            })
          }
          break
        case 'folder':
          if (article_total > 0) {
            return api_response({
              success: false,
              message: '該案卷尚有資料，無法刪除',
            })
          }
          break
        default:
          console.warn('get_article_number_under_organization: unsupported hierarchy:',hierarchy_name)
          return api_response({
            success: false,
            message: '未知的階層名',
          })
        }
      
        return api_response({
          success: true,
        })
      })
      .catch((error) => {
        return api_response({error})
      })
    return result
  },
  async organization_delete ( hierarchy_name, hierarchy_id ) {
    axios.defaults.headers.common['Authorization'] = token.getToken()
  
    let result = axios
    .post(`${this.apiUrl}/organization/delete`, {
      hierarchy_name,
      hierarchy_id
    })
    .then((response) => {
      return api_response({
        success: true,
        payload: response.data,
      })
    })
    .catch((error) => {
      return api_response({error})
    })
    return result
  },
  async delete_faq (id) {
    axios.defaults.headers.common['Authorization'] = token.getToken()
    let result = await axios
      .post(`${this.apiUrl}/frequently-asked-question/delete`, {id})
      .then((response) => {
        return response.data
      })
      .catch((error) => {
        return error
      })
    return result
  },
  async delete_news (id) {
    axios.defaults.headers.common['Authorization'] = token.getToken()
    let result = await axios
      .post(`${this.apiUrl}/news/delete`, {id})
      .then((response) => {
        return response.data
      })
      .catch((error) => {
        return error
      })
    return result
  },
  async online_news (metadata) {
    axios.defaults.headers.common['Authorization'] = token.getToken()
    let result = await axios
      .post(`${this.apiUrl}/news/online`, metadata)
      .then((response) => {
        return response.data
      })
      .catch((error) => {
        return error
      })
    return result
  },
  async add_recommended_article (selected_date, fk_article_system_id) {
    axios.defaults.headers.common['Authorization'] = token.getToken()
    let result = await axios
      .post(`${this.apiUrl}/recommended-article/add`, {selected_date, fk_article_system_id})
      .then((response) => {
        return response.data
      })
      .catch((error) => {
        return error
      })
    return result
  },
  async delete_recommended_article (id) {
    axios.defaults.headers.common['Authorization'] = token.getToken()
    let result = await axios
      .post(`${this.apiUrl}/recommended-article/delete`, {id})
      .then((response) => {
        return response.data
      })
      .catch((error) => {
        return error
      })
    return result
  },

  // search history
  async get_search_history (resource_name) {

    let valid_resource_names = ['article','account','issue-report','theme','news']

    if (typeof resource_name === 'undefined' || resource_name===null) {
      return api_response({error: 'invalid resource name'})
    }
    
    resource_name = normalize_search_resource_name(resource_name)

    if (valid_resource_names.indexOf(resource_name) === -1) {
      return api_response({error: 'not supported resource name: '+ resource_name})
    }
    
    let params = {
        menu_name:{
            value: resource_name,
            action: "="
        }
    }

    let result = axios
    .post(`${this.apiUrl}/user/search-record`, params)
    .then((response) => {
        return api_response({
        success: true,
        payload: response.data,
        })
    })
    .catch((error) => {
        return api_response({error})
    })

    return result
  },

  async add_search_history (resource_name, keyword) {

    let valid_resource_names = ['article','account','issue-report','theme','news']

    if (typeof resource_name === 'undefined' || resource_name===null) {
      return api_response({error: 'invalid resource name'})
    }

    resource_name = normalize_search_resource_name(resource_name)

    if (valid_resource_names.indexOf(resource_name) === -1) {
      return api_response({error: 'not supported resource name: '+ resource_name})
    }
    
    let params = {
        menu_name: resource_name,
        keyword
    }

    let result = axios
    .post(`${this.apiUrl}/user/add-search-record`, params)
    .then((response) => {
        return api_response({
        success: true,
        payload: response.data,
        })
    })
    .catch((error) => {
        return api_response({error})
    })

    return result
  },

  async list_browse_times (month) {
    
    // let params = {
    //     month
    // }

    let result = axios
    .post(`${this.apiUrl}/browse-times/list`, {})
    .then((response) => {
        return api_response({
        success: true,
        payload: response.data.payload,
        })
    })
    .catch((error) => {
        return api_response({error})
    })

    return result
  },

  // site-admin
  async download_site_config() {
    axios.defaults.headers.common['Authorization'] = token.getToken()

    let ret = axios.get(`${this.apiUrl}/site-admin/get-config`,)
    .then(response => {
        if (response.status === 200) { 
          try { 
            if (response.data && response.data.success === false) {
              return api_response({
                success: false,
                message: response.data.message,
              })
            }
      
            downloadFile({
              response,
              assigned_file_name: 'ldf_site.cfg',
              type: 'application/octet-stream'
            })
            return api_response({success: true})

          } catch (error) {
            return api_response({error})
          }
        }
        else {
          return api_response({success: false})
        }
    })
    .catch(error => {
      console.warn('[ERR] failed to download template file, error=', error)
      return api_response({error})
    })

    return ret

  },
  async upload_site_config(file) {
    axios.defaults.headers.common['Authorization'] = token.getToken()
    
    let param = new FormData(); 
    param.append('file[0]', file.file)

    let config = { headers:{'Content-Type':'multipart/form-data'} } 

    let result = axios
      .post(`${this.apiUrl}/site-admin/set-config`, param, config)
      .then((response) => {
        if (response.status === 200) { 
          if ( response.data.success == true ) {
            return api_response({
              success: true,
              payload: response.data.payload,
              message: response.data.message,
            })
          }
          else {
            return api_response({
              success: false,
              message: response.data.message,
            })
          }
        }
        else {
          return api_response({success: false})
        }
      })
      .catch((error) => {
        return api_response({
          error: error,
          message: error.response.data.message
        })
      })
    return result

  },
}

